module.exports = __webpack_public_path__ + "img/logo.1ed2c220.svg";